export function deriveInitials(name?: string | null, fallback?: string | null): string {
  if (name && name.trim().length > 0) {
    const parts = name.trim().split(/\s+/)
    const first = parts[0]?.charAt(0) ?? ''
    const second = parts[1]?.charAt(0) ?? ''
    return (first + second).toUpperCase() || '?'
  }
  if (fallback && fallback.trim().length > 0) {
    return fallback.trim().slice(0, 2).toUpperCase()
  }
  return '?'
}
